import { CAPTION_LANGUAGES } from '@src/constants/caption-languages';
import { withTitleAndDate } from '@src/helpers/brandingVersionHelpers';

const isBrandingVersion = (version) =>
  version?.kind === 'branding' || version?.label === 'branded';

// Branding burns are merged into the same versions list and rendered by the same row (see
// VpMediaSubTable), so these helpers see both kinds. Without an explicit branch the
// "anything that is not captioned is a translation" rule mislabels a branded version.
export const formatVersionLabel = (version) => {
  if (!version?.label) return 'Version';
  // A branding-only burn is already Branded; the suffix below would read "Branded + Branded".
  if (isBrandingVersion(version)) return 'Branded';

  const base = version.label === 'captioned' ? 'Captioned' : 'Translation';
  return version.hasBranding ? `${base} + Branded` : base;
};

export const getVersionLanguageLabel = (version) => {
  if (!version) return null;
  // A branding burn has no language. Falling through would use its own label as a language
  // code and render a meaningless "BRANDED" chip beside the real one.
  if (isBrandingVersion(version)) return null;
  const code = version.label === 'captioned' ? version.sourceLanguage : (version.targetLanguage || version.label);
  if (!code) return null;
  const lang = CAPTION_LANGUAGES.find((l) => l.code === code);
  return lang ? lang.label : code?.toUpperCase();
};

/**
 * The label every surface that lists versions should use.
 *
 * `formatVersionLabel` alone returns a flat kind for every burn, so two burns of the same kind on
 * one media are indistinguishable — which is what the media tab's sub-table showed until it
 * started calling this instead. One rule for all four kinds: the kind, then whatever tells this
 * burn apart from its siblings.
 *
 * Display only: the download filename still uses the flat label, because this one carries a date
 * with slashes in it.
 */
export const formatMediaVersionLabel = (version) => (
  withTitleAndDate(formatVersionLabel(version), version)
);



// WEBPACK FOOTER //
// ./src/helpers/captionVersionHelpers.js